// extracted by mini-css-extract-plugin
export default {"grammarPage":"GrammarPage_grammarPage__Sko96","title":"GrammarPage_title__DhpaO","grammarPage__mobile":"GrammarPage_grammarPage__mobile__cWNt7"};